<template>
  <div
    v-if="getFreeSearchBookListStore.showSortResults"
    class="results-container"
    v-click-outside="hideSortResults"
  >
    <div class="title">{{ $t("freeSearchResults.title") }}</div>
    <div
      @click="filter(result)"
      class="result-item"
      v-for="result in list"
      :key="result.id"
      :class="{ active: isActive(result.id) }"
    >
      <span class="item-title">{{ result.title }}</span>
      <span class="item-num">({{ result.num.toLocaleString() }})</span>
    </div>
  </div>
</template>

<script>
import { createFreeSearchBookListStore } from "@/store_pinia";

export default {
  props: ["searchId"],
  computed: {
    freeSearchBookListStore() {
      return createFreeSearchBookListStore(this.searchId);
    },
    getFreeSearchBookListStore() {
      return this.freeSearchBookListStore || {};
    },
    list() {
      let list = this.getFreeSearchBookListStore.sortResults;
      let all = 0;
      list.forEach((l) => {
        all += l.num;
      });
      let allResults = [
        {
          id: 0,
          title: this.$t("freeSearchResults.allResultsTitle"),
          num: all,
        },
      ];
      return allResults.concat(list);
    },
  },
  methods: {
    hideSortResults() {
      this.getFreeSearchBookListStore.setShowSortResults(false);
    },
    isCurrentFilter(id) {
      return this.getFreeSearchBookListStore.currentFilter == id;
    },
    isActive(id) {
      return this.isCurrentFilter(id);
    },
    filter(item) {
      this.getFreeSearchBookListStore.setCurrentFilter(item.id);
      this.getFreeSearchBookListStore.setShowSortResults(false);
    },
  },
};
</script>

<style lang="scss" scoped>
.results-container {
  height: auto;
  width: 150px;
  position: absolute;
  left: 0px;
  top: 0px;
  box-shadow: 0 2px 3px 1px #0000005c;
  background-color: #fff;
  // padding: 5px;
  z-index: 10000;
}
.result-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  white-space: nowrap;
  padding: 0 8px;
  text-align: right;
  height: 28px;
  line-height: 28px;
  font-size: 13px;
  cursor: pointer;
}
.result-item:hover {
  background-color: #ececec;
}
.result-item.active {
  background-color: #ececec;
}
.title {
  height: 24px;
  line-height: 24px;
  padding: 0 7px;
  color: #636363;
  font-weight: bold;
  font-size: 12px;
}
.item-num {
  color: rgba(0, 0, 0, 0.5);
}
</style>
